import { useEffect, useMemo } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";

const UpdateNavigation = ({ baseUrl, registrationAvailable }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const { pathname } = location;
    const hasReceiptId = !!params?.receiptId;

    // these are routes which need to be redirected to the classification page
    const automaticClassificationRedirects = useMemo(
        () => [
            `${baseUrl}`,
            `${baseUrl}/`,
            `${baseUrl}/form`,
            `${baseUrl}/form/`,
        ],
        [baseUrl],
    );

    // handles the different variations of the "home" route
    useEffect(() => {
        if (
            registrationAvailable &&
            automaticClassificationRedirects.includes(pathname)
        ) {
            navigate(`${baseUrl}/form/classification`);
        }
    }, [
        pathname,
        baseUrl,
        navigate,
        automaticClassificationRedirects,
        registrationAvailable,
    ]);

    // handles the closed form redirect
    useEffect(() => {
        if (!registrationAvailable && !hasReceiptId) {
            navigate(`${baseUrl}/form/closed`);
        }
    }, [registrationAvailable, navigate, baseUrl, hasReceiptId]);

    return null;
};

UpdateNavigation.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    registrationAvailable: PropTypes.bool.isRequired,
};

export default UpdateNavigation;
